const report = {
  logistics: "التقارير",
  listIssuesBreadcrumb: "قائمة الحالات",
  listReportBreadcrumb: "تفاصيل التقرير",
  listReport: {
    noDataFound: "عذراً، لا توجد قضايا",
    noReportsFound: "لا توجد تقارير",
    open: "مفتوح",
    closed: "مغلق",
    reportList: "قائمة التقارير",
    reportTitle: "عنوان التقرير",
    eventName: "اسم الفعالية",
    zones: "المناطق",
    zone: "المنطقة",
    name: "اسم المبلّغ",
    role: "منصب المبلّغ",
    supervisor: "المشرف",
    createdDate: "تاريخ الإنشاء",
    createdTime: "وقت الإنشاء",
    dateTime: "التاريخ والوقت",
    createdDateTime: "تاريخ ووقت الإنشاء",
    closedDateTime: "تاريخ ووقت الإغلاق",
    closedTime: "وقت الإغلاق",
    closedDate: "تاريخ الإغلاق",
    date: "التاريخ",
    time: "الوقت",
    status: "الحالة",
    zoneNo: "رقم المنطقة",
    issueDesc: "وصف الحالة",
    images: "الصور",
  },
  modalTitle: "تصدير التقرير",
  exportModalDescription: "حدد الحقول التي تريد تضمينها في ملفك.",
  selectAllFields: "تحديد كل الحقول",
  searchPlaceholder: "البحث بعنوان التقرير",
  filter: "تصفية",
  reporterPosition: "منصب المبلّغ",
  reportedAt: "تاريخ البلاغ",
  resolvedAt: "تاريخ الحل",
  dateRangeFilter: {
    from: "من تاريخ",
    to: "إلى تاريخ",
  },
  reporterPositions: {
    supervisor: "مشرف",
    employee: "موظف",
    yoramAdmin: "مسئول يُرام",
  },
  showingRange: "عرض {from}-{to} من {total} تقارير",
  emptyTitle: "لا توجد تقارير بعد",
  emptyDescription: "أضف أول تقرير للبدء.",
  eventEmptyDescription:
    "ستظهر التقارير هنا بمجرد تقديم مشكلة خلال هذه الفعالية.",
  noResultsTitle: "لا توجد تقارير",
  noResultsDescription: "لا توجد تقارير تطابق البحث أو الفلاتر.",
  addReport: {
    addReport: "إضافة تقرير",
    addNewReport: "إضافة تقرير جديد",
    title: "إضافة تقرير جديد",
    description: "قدّم بلاغاً جديداً عن مشكلة أو حادثة للمراجعة.",
    submit: "إرسال التقرير",
    reportTitle: "عنوان التقرير",
    reportTitlePlaceholder: "مثال: خطر سلامة عند مدخل المنطقة أ",
    event: "الفعالية",
    eventPlaceholder: "اختر الفعالية",
    zone: "المنطقة المتأثرة",
    zonePlaceholder: "اختر الموقع",
    issueDescription: "الوصف",
    issueDescriptionPlaceholder: "اكتب تفاصيل المشكلة هنا...",
    descriptionHint: "بحد أقصى 300 حرف. يُسمح بالأحرف والأرقام والرموز الخاصة.",
    descriptionMaxLengthError: "لا يمكنك إدخال أكثر من 300 حرف.",
    reportStatus: "حالة التقرير",
    uploadLabel: "رفع مرفق",
    uploadClickToUpload: "انقر للرفع",
    uploadDragHint: "أو اسحب وأفلت",
    uploadHint: "PNG أو JPG فقط — بحد أقصى 10 ميجابايت لكل ملف، حتى 4 ملفات.",
    uploadFormatHint: "PNG أو JPG فقط — بحد أقصى 10 ميجابايت لكل ملف.",
    uploadRemainingHint: "يمكنك رفع {count} صورة إضافية.",
    uploadLimitReached:
      "وصلت إلى الحد الأقصى (4 صور). لا يمكنك رفع صور إضافية.",
    uploadMaxSizeError: "الحجم الأقصى 10 ميجابايت",
    uploadTypeError: "التنسيقات المقبولة هي jpg و png فقط",
    required: "هذا الحقل مطلوب",
  },
  exportSheetColumns: {
    reportList: "قائمة التقارير",
    reportName: "اسم التقرير",
    description: "الوصف",
    attachments: "المرفقات",
    reportedDate: "تاريخ البلاغ",
    reportedTime: "وقت البلاغ",
    reporterName: "اسم المبلّغ",
    reporterPosition: "منصب المبلّغ",
    status: "الحالة",
    resolutionDate: "تاريخ الحل",
    resolutionTime: "وقت الحل",
    zone: "المنطقة",
    zoneSupervisor: "مشرف المنطقة",
    comments: "التعليقات",
    eventName: "اسم الفعالية",
    supervisor: "المشرف",
    export: "تصدير",
    exportReportToExcel: "تصدير التقارير إلى ملف إكسل",
  },
  noPreview: "لا توجد معاينة متاحة!",
  updates: "تعليقات",
  viewReport: {
    breadcrumbReport: "التقارير",
    reportId: "رقم التقرير",
    priority: "الأولوية",
    metadata: "نظرة عامة على التقرير",
    reportedDate: "تاريخ البلاغ",
    reportedTime: "وقت البلاغ",
    reportedAt: "تاريخ البلاغ",
    resolvedAt: "تاريخ الحل",
    durationOpen: "مدة الفتح",
    durationHoursUnit: "س",
    durationMinutesUnit: "د",
    evidenceMedia: "الأدلة والوسائط",
    filesAttached: "{count} ملفات مرفقة",
    reportingBy: "مُبلَّغ بواسطة",
    noComments: "لا توجد تعليقات بعد.",
    emptyCommentsTitle: "لم تتم إضافة تعليقات بعد",
    emptyCommentsDescription:
      "أضف تعليقات وتحديثات متعلقة بهذا التقرير لفريقك.",
    addCommentPlaceholder: "أضف تعليقاً...",
    commentMaxLengthError: "لا يمكنك إدخال أكثر من 300 حرف.",
    postComment: "نشر التعليق",
    resolveIssue: "حل المشكلة",
    viewProfile: "عرض الملف الشخصي",
  },
  resolveReport: {
    title: "حل المشكلة",
    description: "هل أنت متأكد أنك تريد تعليم هذه المشكلة كمحلولة؟",
    commentLabel: "وصف الحل",
    commentPlaceholder: "صف كيف تم حل المشكلة...",
    confirm: "حل",
    uploadClickToUpload: "انقر للرفع",
    uploadDragHint: "أو اسحب وأفلت",
    uploadHint: "PNG أو JPG فقط — بحد أقصى 10 ميجابايت لكل ملف، وحتى 4 صور إجمالاً.",
    uploadFormatHint: "PNG أو JPG فقط — بحد أقصى 10 ميجابايت لكل ملف.",
    uploadRemainingHint: "يمكنك رفع {count} صورة إضافية.",
    uploadLimitReached:
      "وصلت إلى الحد الأقصى (4 صور). لا يمكنك رفع صور إضافية.",
    uploadMaxSizeError: "الحجم الأقصى 10 ميجابايت",
  },
  deleteModal: {
    title: "حذف الملف",
    content: "هل أنت متأكد أنك تريد حذف هذا الملف؟",
  },
};

export default report;
